import { build_settings } from "../assets/custom/settings";
import { locale } from "../locale";
import { isSelfAdmin } from "../states/adminsState";
import { authState } from "../states/auth";
import { addGarantedInCallNotification } from "../states/notifications";
import { roomState, serverDiffTime } from "../states/room";

const MIN = 1000 * 60;
const HOUR = MIN * 60;
const FREE_TIME = MIN * 15;
const PAY_TIME = HOUR * 6;

export function watch5MinNotification() {
  if (build_settings.disable_tariff_feature) {
    return
  }
  if (isSelfAdmin.value) {
    let int = setInterval(() => {
      let duration =
        Date.now() -
        new Date(roomState.startCall as string).getTime() -
        serverDiffTime.value;
      let lesstime = 0
      if (authState.tarif === "FREE") {
        lesstime = FREE_TIME - duration
      } else if (authState.tarif === "PAY") {
        lesstime = PAY_TIME - duration
      }
      if(lesstime < 5*MIN) {
        clearInterval(int)
        addGarantedInCallNotification(4, locale.less5min)
      }
    }, 5000);
  }
}
